import React from "react"
import styled from "styled-components"
import EvaluationHost from "./EvaluationHost"

const resolveGooglePlaceId = (almacenInfo) =>
    almacenInfo?.place_id ||
    almacenInfo?.placeId ||
    almacenInfo?.resto?.place_id ||
    almacenInfo?.resto?.placeId ||
    almacenInfo?.restaurant?.place_id ||
    almacenInfo?.restaurant?.placeId ||
    almacenInfo?.restoInfo?.place_id ||
    almacenInfo?.restoInfo?.placeId ||
    ""

const ThankYouPage = ({
    noVoting = false,
    onSelection,
    onNoVoting,
    onThanksPage,
    congrats,
    almacenInfo,
    customQuestions=[],
}) => {
    if (noVoting) {
        return (
            <Wrapper>
                <Inner>
                    {congrats ? (
                        <ThankYouContainer>
                            <Title>¡Gracias por tu valoración!</Title>
                            <Subtitle>Hemos recibido tus respuestas</Subtitle>
                            <Spacer />
                            <Paragraph>
                                Tu opinión nos ayuda a mejorar la experiencia en tu próxima
                                visita.
                            </Paragraph>
                        </ThankYouContainer>
                    ) : (
                        <ThankYouContainer>
                            <Title>¡Gracias por tu valoración!</Title>
                            <Paragraph>¡Esperamos tu calificación en tu próxima visita!</Paragraph>
                        </ThankYouContainer>
                    )}
                </Inner>
            </Wrapper>
        )
    }

    return (
        <Wrapper>
            <Inner>
                <ThankYouContainer>
                    <Title>¡Gracias por tu like!</Title>
                    <Heading>Responde estas preguntas.</Heading>
                    <Paragraph>Tu opinión nos ayuda a mejorar.</Paragraph>
                </ThankYouContainer>

                <EvaluationHost
                    onSelection={onSelection}
                    onNoVoting={onNoVoting}
                    onThanksPage={onThanksPage}
                    customQuestions={customQuestions}
                />
            </Inner>
        </Wrapper>
    )
}

export default ThankYouPage

/* ========== styled-components ========== */

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

const Inner = styled.div`
  width: 100%;
  max-width: 720px;
`

const ThankYouContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 40px 0 20px;
  gap: 8px;
`

const Title = styled.h1`
  font-size: 22px;
  font-weight: 600;
  color: #111827;
  margin: 0;
`

const Subtitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin: 0;
`

const Paragraph = styled.p`
  margin: 0;
  font-size: 14px;
  color: #374151;
`

const Spacer = styled.div`
  height: 12px;
`

const Heading = styled.h6`
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #111827;
`
